import { pick } from 'lodash';
import { parseSubscriptionStatus } from 'src/common/components/SubscriptionStatus/constants/subscriptionStatus';
import { cleanDefaultValuesURLSearchParams } from 'src/common/utils/urlSearchParamsUtils';
import { ActiveProfileFilter } from 'src/rSimInventory/constants/activeProfile';
import { LastUpdateTimeFilter } from 'src/rSimInventory/constants/lastUpdate';
import { RSimFilters, RSIM_INITIAL_FILTERS } from 'src/rSimInventory/constants/rsim';
import { SimulateOutageFilter } from 'src/rSimInventory/constants/simulateOutage';

export const mapRSimFiltersToURLSearchParams = (rsimFilters: RSimFilters) => {
  const cleanedFiltersValues = cleanDefaultValuesURLSearchParams(rsimFilters, RSIM_INITIAL_FILTERS);
  return new URLSearchParams(cleanedFiltersValues);
};

export const mapURLSearchParamsToRsimFilters = (urlSearchParams: URLSearchParams): RSimFilters => {
  const filters = Object.fromEntries(urlSearchParams);

  const {
    connectionId,
    orderNumber,
    tags,
    accounts,
    productCodes,
    subscriptionStatus,
    lastActiveProfile,
    lastUpdateTime,
    simulateOutage,
    mobileNetworkOperator,
    mobileNetworkOperatorId,
    mnoNames,
    ...cleanedFiltersValues
  } = pick(filters, Object.keys(RSIM_INITIAL_FILTERS));

  return {
    ...RSIM_INITIAL_FILTERS,
    ...cleanedFiltersValues,
    connectionId: connectionId ?? RSIM_INITIAL_FILTERS.connectionId,
    orderNumber: orderNumber ?? RSIM_INITIAL_FILTERS.orderNumber,
    lastActiveProfile: lastActiveProfile
      ? (lastActiveProfile as ActiveProfileFilter)
      : RSIM_INITIAL_FILTERS.lastActiveProfile,
    lastUpdateTime: lastUpdateTime
      ? (lastUpdateTime as LastUpdateTimeFilter)
      : RSIM_INITIAL_FILTERS.lastUpdateTime,
    simulateOutage: simulateOutage
      ? (simulateOutage as SimulateOutageFilter)
      : RSIM_INITIAL_FILTERS.simulateOutage,
    tags: tags ? tags.split(',') : RSIM_INITIAL_FILTERS.tags,
    mobileNetworkOperator: mobileNetworkOperator
      ? mobileNetworkOperator.split(',')
      : RSIM_INITIAL_FILTERS.mobileNetworkOperator,
    mnoNames: mnoNames ? mnoNames.split(',') : RSIM_INITIAL_FILTERS.mnoNames,
    mobileNetworkOperatorId: mobileNetworkOperatorId
      ? mobileNetworkOperatorId.split(',').map((value) => Number.parseInt(value))
      : RSIM_INITIAL_FILTERS.mobileNetworkOperatorId,
    accounts: accounts
      ? accounts.split(',').map((account) => (account === 'null' ? null : account))
      : RSIM_INITIAL_FILTERS.accounts,
    productCodes: productCodes
      ? productCodes.split(',').map((productCode) => (productCode === 'null' ? null : productCode))
      : RSIM_INITIAL_FILTERS.productCodes,
    subscriptionStatus: subscriptionStatus
      ? subscriptionStatus
          .split(',')
          .map((subscriptionStatus) => parseSubscriptionStatus(subscriptionStatus))
      : RSIM_INITIAL_FILTERS.subscriptionStatus,
  };
};
